import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
//import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import ThemeDefault from '../../theme-default';
import axios from 'axios';
import urlBase from '../../url-base';
import {
   Button
} from 'reactstrap';
import {  Styles } from '../../styles/theme';


class LoginPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errorFormat: ''
    };

    this.styles = {
      loginContainer: {
        minWidth: 320,
        maxWidth: 400,
        height: 'auto',
        position: 'absolute',
        top: '11%',
        left: 0,
        right: 0,
        margin: 'auto'
        
      },
      paper: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop:40,
        paddingBottom:30,
        //overflow: 'auto',
        marginTop: 30, 
        height: 390,
      },
      loginBtn: {
        float: 'right'
      },
      logo: {
        width: 344,
        height:64,
        backgroundImage:  'url(' + require('../../assets/images2/new_layout/logo_dental_plano_odontologico.svg') + ')',
        backgroundSize:'100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        margin: '0px auto 30px auto'
      },
      img_background: {
        width: "100%",
        height:400,
        backgroundImage:  'url(' + require('../../assets/images2/background-login.png') + ')',
        backgroundSize:'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        margin: '0px auto 0px auto',
        bottom:0,
        position:'absolute',
      },
      h1: {
        textAlign: 'center',
        fontSize: 28,
        fontWeight: 500,
        color: '#d10424',
        marginBottom: 0,
        textTransform: 'uppercase',
      },
      h2: {
        textAlign: 'center',
        fontSize: 22,
        fontWeight: 500,
        color: '#757575',
        marginBottom: 0,
        textTransform: 'uppercase',
      }
    };

    this.errorField = {
      email: '',
      password: ''
    };

    this.errorFormat = {
      email: ''
    };

  }


  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.type === 'email')
      this.onBlurField(e);

    if (e.target.value === '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  // Valida campos de e-mail
  onBlurField(e) {
    // Se o campo for do tipo email
    if (e.target.type === 'email') {
      // Se o conteúdo não for válido
      if (!e.target.validity.valid)
        this.errorFormat.email = 'Formato esperado: email@exemplo.com';
      // Se o conteúdo for válido, retira mensagem de erro
      else
        this.errorFormat.email = '';
    }
  }

  // Valida campos em branco (form login)
  validationFields() {
    let fields = ['email', 'password'];
    let message = 'Campo obrigatório';

    for (let i = 0; i < fields.length; i++) {
      if (this.state[fields[i]] === '') {
        this.errorFormat[fields[i]] = message;
        this.setState(this.state);
        return false;
      }
      else
        this.errorFormat[fields[i]] = '';
    }
    this.setState(this.state);
    return true;
  }

 /* FUNÇÕES PARA SEREM UTILIZADA NO TRATAMENTO DA EXPIRAÇÃO DA SEÇÃO
 setStorageWithTTL(key, value, ttlInMs) {
  var now = new Date().getTime();
  var item = {
    value: value,
    expiry: now + ttlInMs // Grava o momento exato em que vai expirar
  };
  window.localStorage.setItem(key, JSON.stringify(item));
}

// Função para ler do localStorage verificando se o tempo já venceu
 getStorageWithTTL(key) {
  var itemStr = window.localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    var item = JSON.parse(itemStr);
    var now = new Date().getTime();

    // Se a data/hora atual passou do limite (expiry), apaga do cache e retorna null
    if (item.expiry && now > item.expiry) {
      window.localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    // Se for um dado antigo gravado sem o formato de objeto/TTL
    return itemStr;
  }
}
*/
onSubmitForm(e) {
  e.preventDefault();

  // Limpa mensagem de erro anterior no estado do React
  this.setState({ errorMessage: '' });

  var fields = {
    email: this.state.email,
    password: this.state.password
  };

  if (!this.validationFields()) {
    return;
  }

  var self = this;

  axios.post(urlBase.loopBack + 'Accounts/login?include=USER', fields)
    .then(function (result) {
      var authData = result.data;

      if (!authData || !authData.user || authData.user.active !== true) {
        // Se a conta estiver inativa, lança um erro para cair no catch ou trata direto
        throw new Error('USER_INACTIVE');
      }

      window.localStorage.setItem('dental_t', authData.id || '');
      window.localStorage.setItem('dental_u', authData.userId || '');
      window.localStorage.setItem('dental_y', authData.user.type || '');
      window.localStorage.setItem('dental_n', authData.user.name || '');
      window.localStorage.setItem('dental_i', authData.user.image || '');

      var codeS4 = (authData.user.codeS4 && authData.user.codeS4 > 0) ? authData.user.codeS4 : '';
      window.localStorage.setItem('dental_codeS4', codeS4);

      // Busca o vendedor
      var salesmanFilter = JSON.stringify({
        where: { userId: authData.userId }
      });

      return axios.get(urlBase.loopBack + 'Salesmans?filter=' + encodeURIComponent(salesmanFilter));
    })
    .then(function (salesmanRes) {
      if (!salesmanRes) return;

      var salesmanData = salesmanRes.data;

      if (salesmanData && salesmanData.length > 0 && salesmanData[0].cpf) {
        var cleanCpf = salesmanData[0].cpf.replace(/\D/g, '');
        var s4Url = urlBase.loopBack + 'APIS4s/Vendedores';
        return axios.post(s4Url, { cpf: cleanCpf });
      }

      return Promise.resolve(null);
    })
    .then(function (s4Res) {
      if (s4Res && s4Res.data && s4Res.data.length > 0 && s4Res.data[0].CodCentroCusto) {
        window.localStorage.setItem('dental_cc', s4Res.data[0].CodCentroCusto);
      } else {
        window.localStorage.setItem('dental_cc', '');
      }

      // Redireciona somente após a conclusão do fluxo
      window.location.href = urlBase.client + "panel";
    })
    .catch(function (erro) {
      console.error('Erro no login:', erro);

      var errorMsg = 'Erro no servidor. Contacte o responsável.';

      if (erro.message === 'USER_INACTIVE') {
        errorMsg = 'Sem permissão. Contacte o responsável.';
      } else if (erro.response && (erro.response.status === 401 || erro.response.status === 400 || erro.response.status === 404)) {
        // Erro 401 do LoopBack / dados incorretos
        errorMsg = 'Dados incorretos. Tente novamente.';
      }

      // 1. Atualiza no estado do React
      self.setState({ errorMessage: errorMsg });

      // 2. Fallback caso você ainda use o elemento HTML i_error_submit direto no DOM
      var el = document.getElementById('i_error_submit');
      if (el) {
        el.innerHTML = errorMsg;
        el.style.display = 'block';
      }
    });
}

  render() {
    return (
      <MuiThemeProvider muiTheme={ThemeDefault}>

        <div>
          <div style={this.styles.loginContainer}>

            <div style={this.styles.logo}>&nbsp;</div>
            <h1 style={this.styles.h1}>Planos Dental Center</h1>
            <h1 style={this.styles.h2}>Plataforma de Vendas</h1>

            <Paper style={this.styles.paper}>

              <form onSubmit={this.onSubmitForm.bind(this)}>
                <p
                  id="i_error_submit"
                  style={{color: "rgb(244, 67, 54)", display: "none"}}
                >
                  Dados incorretos. Tente novamente.
                </p>

                <TextField
                  errorText={this.errorFormat.email}
                  hintText="E-mail"
                  floatingLabelText="E-mail"
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.onChange.bind(this)}
                  onBlur={this.onBlurField.bind(this)}
                  fullWidth={true}
                />
                <TextField
                  errorText={this.errorFormat.password}
                  hintText="Senha"
                  floatingLabelText="Senha"
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.onChange.bind(this)}
                  fullWidth={true}
                />
                <div style={{ marginTop: 15}}>
                  <a href={urlBase.client + 'forgot-password'}>
                    <span style={{color: "rgb(133, 133, 133)",fontSize:"12px", textDecoration:"underline" }}>Esqueceu a senha?</span>
                  </a>
                </div>
                <br/>
                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '5px' }}>
                  <Button
                        type="submit"
                        color="primary"
                        fullWidth
                        style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                          onClick={this.onSubmitForm.bind(this)}
                        >
                        Login
                  </Button> 
                 
                </div>

              </form>
            </Paper>
          </div>
        </div>

      </MuiThemeProvider>

    );
  }


}


export default LoginPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/LoginPageNew.js
 **/